<template>
	<div>
		<a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" @submit.native.prevent="handleSubmit"
			class="product-tab">
			<!-- 品牌介绍 -->
			<a-form-item label="品牌介绍" v-if="ifFacOrBr=='2'" :auto-link="false">
				<div>
					<div style="margin-bottom: 4px;">
						<a-button size="small" @mousedown.prevent="execCmd('bold', 'businessDesc')"><b>B</b></a-button>
						<input type="color" @focus="saveRange" @change="applyColorChange('businessDesc', $event)"
							   style="width: 24px; height: 24px; border: none; cursor: pointer; vertical-align: middle; margin-left: 4px;"
							   title="文字颜色"/>
							<a-button size="small" @mousedown.prevent="applyLastColor('businessDesc')" style="margin-left: 4px;">确定</a-button>
					</div>
					<div contenteditable="true"
						 ref="businessDescEditor"
						 @input="onRichInput('businessDesc')"
						 @blur="onRichBlur('businessDesc')"
						 class="rich-editor">
					</div>
					<a-input v-decorator="['businessDesc', {
        rules: [
        ]
      }]" style="display: none;"/>
				</div>
			</a-form-item>
			<!-- 主体名称 -->
			<a-form-item label="主体名称">
				<a-input placeholder="请输入主体名称"
					v-decorator="['entityName', { rules: [{ required: true, message: '请输入主体名称' }] }]"
					@input="handleFormChange" />
			</a-form-item>

			<!-- LOGO图标 -->
			<a-form-item label="LOGO图标" :auto-link="false">
				<div v-decorator="['logoUrl', {
        rules: [
          { required: true, message: '请上传LOGO图标' },
          { validator: validateLogo }
        ]
      }]" style="display: none;"></div>
				<div style="display: flex;align-items: center;">
					<div v-if="baseInfo.logoUrl">
						<viewer :images="[baseInfo.logoUrl]">
							<div class="er_content">
								<img class="er_content_img" :src="img" v-for="(img,index) in [baseInfo.logoUrl]"
									:key="index" style="width: 100px;height: 100px;object-fit: contain;">
							</div>
						</viewer>
					</div>
					<div class="again_upload_box ml12">
						<a-spin :spinning="uploadingLogo" size="small">
						<input type="file" accept="image/jpg,image/png" @change="hCandleUpdataFile" :disabled="uploadingLogo" />
						<i class="el-icon-box again_upload_icon"></i>
						<div class="bold" style="width: 100px">
							{{ baseInfo.logoUrl ? "重新上传" : "上传logo" }}
						</div>
						</a-spin>
					</div>
				</div>
				<div style="color:#999;margin-top:4px">只能上传1张，jpg/png格式，文件不超过3M</div>
			</a-form-item>

			<!-- 统一社会信用代码 18位 字母+数字 -->
			<a-form-item label="统一社会信用代码">
				<a-input placeholder="请输入18位统一社会信用代码" v-decorator="['unifiedSocialCreditCode', {
        rules: [
          { required: true, message: '请输入统一社会信用代码' },
          { len: 18, message: '长度必须为18位' },
          { pattern: /^[A-Za-z0-9]+$/, message: '只能包含字母和数字' }
        ]
      }]" @input="handleFormChange" />
			</a-form-item>

			<!-- 存续状态 输入框+颜色 -->
			<a-form-item label="存续状态" :auto-link="false">
				<div style="display: flex; align-items: center; gap: 8px;">
					<a-input placeholder="请输入存续状态" v-decorator="['businessStatus', { rules: [{ required: true, message: '请输入存续状态' }] }]" style="width: 160px;" @input="handleFormChange" />
					<div style="display: flex; align-items: center; gap: 4px;">
						<label style="font-size: 12px; color: #666;">颜色</label>
						<input type="color" v-model="businessStatusColor" style="width: 32px; height: 32px; border: none; cursor: pointer; padding: 0;" @change="onBusinessStatusColorChange" />
					</div>
				</div>
			</a-form-item>

			<!-- 标签显示 非必填 标签形式 -->
			<a-form-item label="标签显示" :auto-link="false">
				<div v-if="tagList.length > 0" style="margin-bottom:8px;">
					<a-tag v-for="(tag,idx) in tagList" :key="idx" closable @close="removeTag(idx)" style="margin-bottom:4px;">{{ tag }}</a-tag>
				</div>
				<div style="display:flex;gap:8px;">
					<a-input ref="tagInput" v-model="tagInput" placeholder="输入标签后点新增" style="width:160px;" @pressEnter="addTag" />
					<a-button type="primary" size="small" @click="addTag">+ 新增</a-button>
				</div>
				<div v-decorator="['tags']" style="display:none;"></div>
			</a-form-item>

			<!-- 法人代表 -->
			<a-form-item label="法人代表">
				<a-input placeholder="请输入法人代表" v-decorator="['legalRepresentative', {
        rules: [
          { required: true, message: '请输入法人代表' },
        ]
      }]" @input="handleFormChange" />
			</a-form-item>

			<!-- 注册资本 -->
			<a-form-item label="注册资本">
				<a-input placeholder="例：1000万元" v-decorator="['registeredCapital', {
        rules: [
          { required: true, message: '请输入注册资本' },
        ]
      }]" @input="handleFormChange" />
			</a-form-item>

			<!-- 成立时间 年月日选择器 -->
			<a-form-item label="成立时间">
				<a-date-picker format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" placeholder="请选择成立时间" :disabled="baseInfo.lang === 'EN'"
					v-decorator="['establishDate', { rules: [{ required: true, message: '请选择成立时间' }] }]" />
			</a-form-item>

			<!-- 自有工厂 - 仅品牌 -->
<!--			<a-form-item label="自有工厂" v-if="ifFacOrBr=='2'">-->
<!--				<a-radio-group v-model="hasOwnFactoryStatus" style="display: flex; align-items: center; white-space: nowrap; gap: 8px; padding-left: 4px;">-->
<!--					<a-radio :value="true">是</a-radio>-->
<!--					<a-radio :value="false">否</a-radio>-->
<!--					<a-input v-if="!hasOwnFactoryStatus" v-model="hasOwnFactorylabel" placeholder="请输入自有工厂标签" style="flex: 1; min-width: 120px;" />-->
<!--				</a-radio-group>-->
<!--			</a-form-item>-->

			<!-- 国标行业 -->
			<a-form-item label="国标行业" >
				<a-input placeholder="请输入国标行业" v-decorator="['industryCategory', {
        rules: [
          { required: true, message: '请输入国标行业' },
        ]
      }]" @input="handleFormChange" />
			</a-form-item>

			<!-- 企业规模 -->
			<a-form-item label="企业规模">
				<a-input placeholder="请输入企业规模" v-decorator="['enterpriseScale', {
        rules: [
          { required: true, message: '请输入企业规模' },
        ]
      }]" @input="handleFormChange" />
			</a-form-item>

			<!-- 员工人数 -->
			<a-form-item label="员工人数">
				<a-input placeholder="请输入员工人数" v-decorator="['employeeCount', {
        rules: [
          { required: true, message: '请输入员工人数' },
        ]
      }]" @input="handleFormChange" />
			</a-form-item>

			<!-- 注册地址 -->
			<a-form-item label="注册地址">
				<a-textarea :rows="3" placeholder="请输入注册地址" v-decorator="['registeredAddress', {
        rules: [
          { required: true, message: '请输入注册地址' },
        ]
      }]" @input="handleFormChange" />
			</a-form-item>

			<!-- 经营范围 -->
			<a-form-item label="经营范围">
				<a-textarea :rows="5" placeholder="请输入经营范围" v-decorator="['businessScope', {
        rules: [
          { required: true, message: '请输入经营范围' },
        ]
      }]" @input="handleFormChange" />
			</a-form-item>

			<!-- 监管部门记录 - 仅中文版 -->
		<div style="margin-bottom: 24px; border: 1px solid #e8e8e8; border-radius: 6px; padding: 16px;">
			<div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
				<span style="font-weight: bold; font-size: 16px;">监管部门记录</span>
			</div>
			<div ref="regulatoryRecordsDrag">
				<div v-for="(record, rIdx) in regulatoryRecords" :key="record._key"
					style="border: 1px solid #d9d9d9; border-radius: 6px; padding: 16px; margin-bottom: 12px; cursor: move;">
					<div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
						<span style="font-weight: bold;">{{ record.title }}</span>
						<a-button type="danger" size="small" @click.stop="delRegulatoryRecord(rIdx)">删除</a-button>
					</div>
					<div :ref="'regFieldDrag_' + rIdx" style="margin-bottom: 8px;">
						<template v-for="(f, fIdx) in record.fields">
							<div :key="fIdx" style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px; cursor: move;">
								<a-input v-model="f.key"  style="width: 120px;" />
								<a-textarea v-if="f.type === 'text'" v-model="f.value" :placeholder="f.placeholder || ''" :maxlength="f.max" :rows="2" style="width: 700px;" />
								<a-date-picker v-if="f.type === 'date'" v-model="f.value" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" :placeholder="f.placeholder || '选择日期'" style="width: 200px;" />
								<a-input-number v-if="f.type === 'number'" v-model="f.value" :placeholder="f.placeholder || '输入数字'" style="width: 200px;" />
								<a-checkbox v-model="f.isDisplay">显示</a-checkbox>
								<a-button type="danger" size="small" @click="delField(rIdx, fIdx)">×</a-button>
							</div>
						</template>
					</div>
					<a-button type="dashed" size="small" @click="addField(rIdx)">+ 新增字段</a-button>
				</div>
			</div>
			<a-button type="primary" @click="addRegulatoryRecord" style="margin-top:12px">+ 新增记录</a-button>
			<div v-if="regulatoryRecords.length === 0" style="text-align: center; color: #999; padding: 24px 0;">
				暂无监管部门记录，点击上方按钮新增
			</div>
		</div>
		<a-form-item :wrapper-col="{ span: 12, offset: 5 }">
				<a-button type="primary" html-type="submit">保存</a-button>
			</a-form-item>
		</a-form>
	</div>
</template>

<script>
	import {
		ossUpload
	} from "../../../utils/oss";
	import Sortable from 'sortablejs'
	// 注意路径：根据你的目录结构，从组件文件到json文件的相对路径
	// 正确路径：从组件往上跳 3 级，到 src，再进 assets/json
	import cityData from '../../../assets/json/citys_with_en.json'
	//
	import {
		factoryLicenseInfoApi
	} from "../../../api/index";
	export default {
		name: "BaseInfoTab",
		props: {
			ifFacOrBr: {
				type: String,
				default: ""
			},
			initialData: Object,
		},
		data() {
			return {
				form: this.$form.createForm(this),
				uploadingLogo: false,
				// 本地表单数据
				baseInfo: {},
				// 原始数据（用于对比是否修改）
				originBaseInfo: {},
				list: [],
				categoryIdsList: [],
				regulatoryRecords: [],
				businessStatusColor: '#52c41a',
				hasOwnFactoryStatus: true,
				hasOwnFactorylabel: '',
				tagList: [],
				tagInput: '',
				savedRange: null,
			pickedColor: '',
			lastColor: {},
			};
		},
		mounted() {
			this.$nextTick(() => {
				this.initRegulatoryRecordDrag();
			});
		},
		created() {
			// 初始化：深拷贝赋值
			this.baseInfo = JSON.parse(JSON.stringify(this.initialData || {}));
			this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
		},
		watch: {
			// 监听父组件数据更新 → 自动回填
			initialData: {
				deep: true,
				immediate: true,
				handler(val) {
					if (val) {
						this.initFormData(val);
					}
				}
			}
		},
		methods: {
			// 校验LOGO
			validateLogo(rule, value, callback) {
				const file = this.$refs.logoInput?.files?.[0];
				if (!file && !this.baseInfo.logoUrl) return callback('请上传LOGO图标');
				if (file) {
					const isImg = /image\/(png|jpg|jpeg)$/.test(file.type);
					const isLt1M = file.size / 1024 / 1024 < 1;
					if (!isImg) return callback('只能上传jpg/png格式');
					if (!isLt1M) return callback('图片大小不能超过1MB');
				}
				callback();
			},
			initFormData(data) {
				if (!data) return;
				this.baseInfo = JSON.parse(JSON.stringify(data || {}));
				this.businessStatusColor = this.baseInfo.businessStatusColor || '#52c41a';
				this.hasOwnFactoryStatus = this.baseInfo.hasOwnFactoryStatus !== false;
				this.hasOwnFactorylabel = this.baseInfo.hasOwnFactorylabel || '';
				if (this.baseInfo.businessLangId) {
					this.businessLangId = this.baseInfo.businessLangId
				}
				this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
				// ==============================================
				// antd 表单赋值
				// ==============================================
				this.$nextTick(() => {
					this.form.setFieldsValue({
						// 你当前页面所有表单字段，全部在这里赋值
						entityName: this.baseInfo.entityName || '',
						logoUrl: this.baseInfo.logoUrl || '',
						unifiedSocialCreditCode: this.baseInfo.unifiedSocialCreditCode || '',
						businessStatus: this.baseInfo.businessStatus || '',
						hasOwnFactoryStatus: this.baseInfo.hasOwnFactoryStatus !== false,
						hasOwnFactorylabel: this.baseInfo.hasOwnFactorylabel || '',
						tags: this.baseInfo.tags || '',
						legalRepresentative: this.baseInfo.legalRepresentative || '',
						registeredCapital: this.baseInfo.registeredCapital || '',
						establishDate: this.baseInfo.establishDate || '',
						industryCategory: this.baseInfo.industryCategory || '',
						enterpriseScale: this.baseInfo.enterpriseScale || '',
						employeeCount: this.baseInfo.employeeCount || '',
						registeredAddress: this.baseInfo.registeredAddress || '',
						businessScope: this.baseInfo.businessScope || '',
						businessDesc:this.baseInfo.businessDesc
					});
					// 富文本编辑器内容回显
					this.$nextTick(() => {
						if (this.$refs.businessDescEditor) {
							this.$refs.businessDescEditor.innerHTML = this.baseInfo.businessDesc || '';
						}
					});
				});

				// 加载标签列表
				this.tagList = this.baseInfo.tags ? this.baseInfo.tags.split(';').filter(Boolean) : [];
				// 加载监管部门记录
				if (this.baseInfo.regulatoryRecords) {
					try {
						var parsed = JSON.parse(this.baseInfo.regulatoryRecords);
						if (Array.isArray(parsed) && parsed.length > 0) {
							// parsed 是二维数组 [[{key,value,isDisplay}], [{key,value,isDisplay}]]
							// 接口返回了数据，直接用接口数据，不用 getDefaultFields
							this.regulatoryRecords = parsed.map(function(group, gIdx) {
								var fields = [];
								if (Array.isArray(group)) {
									group.forEach(function(item) {
										fields.push({ key: item.key || '', value: item.value || '', type: 'text', max: 500, isDisplay: item.isDisplay !== false, placeholder: '' });
									});
								}
								return { _key: 'loaded' + gIdx, title: '记录' + (gIdx + 1), fields: fields };
							}, this);
						} else {
							this.regulatoryRecords = [];
						}
					} catch (e) {
						this.regulatoryRecords = [];
					}
				} else {
					this.regulatoryRecords = [];
				}
				if (!this.regulatoryRecords || this.regulatoryRecords.length === 0) {
					this.regulatoryRecords = [
						{ _key: 'def1', title: '记录1', fields: this.getDefaultFields('type1') },
						{ _key: 'def2', title: '记录2', fields: this.getDefaultFields('type2') }
					];
				}
				this.$nextTick(() => {
					this.initRegulatoryRecordDrag();

				});
				this.$emit('dirty', false);
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			// ======================
			// 表单任何变化 → 通知父组件
			// ======================
			handleFormChange() {
				const isModified = JSON.stringify(this.baseInfo) !== JSON.stringify(this.originBaseInfo);
				this.$emit("dirty", isModified);
			},
			// ======================
			// 上传缩略图
			// ======================
			hCandleUpdataFile(e) {
				if (!e.target.files.length) return;
				const file = e.target.files[0];
				if (file.size > 3 * 1024 * 1024) { this.$message.error('图片不能超过3MB'); return; }
				this.uploadingLogo = true;
				ossUpload(file, '', 'image/').then((res) => {
					this.baseInfo.logoUrl = res.url;
					this.form.setFieldsValue({
						logoUrl: res.url
					});
				}).catch(() => {
					this.$message.error('图片上传失败');
				}).finally(() => {
					this.uploadingLogo = false;
				})
			},
			// ======================
			// 富文本编辑器
			// ======================
			saveRange() {
				const sel = window.getSelection();
				if (sel.rangeCount > 0) {
					this.savedRange = sel.getRangeAt(0).cloneRange();
				}
			},
			execCmd(cmd, field) {
				document.execCommand(cmd, false, null);
				this.onRichInput(field);
			},
			applyColorChange(field, event) {
				const color = event.target.value;
				if (!color) return;
				this.lastColor[field] = color;
				if (this.savedRange) {
					const sel = window.getSelection();
					try {
						sel.setBaseAndExtent(
							this.savedRange.startContainer,
							this.savedRange.startOffset,
							this.savedRange.endContainer,
							this.savedRange.endOffset
						);
					} catch (e) {
						sel.removeAllRanges();
						sel.addRange(this.savedRange);
					}
				}
				document.execCommand('foreColor', false, color);
				this.savedRange = null;
				this.onRichInput(field);
			},
			applyLastColor(field) {
				const color = this.lastColor[field];
				if (!color) return;
				document.execCommand('foreColor', false, color);
				this.onRichInput(field);
			},
			execForeColor(field, e) {
				if (this.savedRange) {
					const sel = window.getSelection();
					sel.removeAllRanges();
					sel.addRange(this.savedRange);
				}
				document.execCommand('foreColor', false, e.target.value);
				this.savedRange = null;
				this.onRichInput(field);
			},
			onRichInput(field) {
				const refMap = {
					businessDesc: 'businessDescEditor',
				};
				const refName = refMap[field];
				const el = this.$refs[refName];
				const html = el ? el.innerHTML : '';
				this.form.setFieldsValue({[field]: html});
				this.handleFormChange();
			},
			onRichBlur(field) {
				this.onRichInput(field);
				this.handleFormChange();
			},
			// ======================
			// 新增品类
			// ======================
			addPL() {
				const hasFactory = this.plList.some(item => item.tagId == this.baseInfo.plText);
				if (hasFactory) {
					this.$message.warning('已添加该工厂');
					return;
				} else {
					const factory = this.pinleiList.find(item => item.tagId == this.baseInfo.plText);
					if (factory) {
						this.plList.push(factory);
						this.baseInfo.categoryIds = this.plList.map(item => item.tagId).join(',');
						this.form.setFieldsValue({
							categoryIds: this.baseInfo.categoryIds
						});
					}
				}
			},

			// ======================
			// 删除品类
			// ======================
			deletePaperSize(index) {
				this.plList.splice(index, 1);
				this.baseInfo.categoryIds = this.plList.map(item => item.tagId).join(',');
				this.form.setFieldsValue({
					categoryIds: this.baseInfo.categoryIds
				});
				this.handleFormChange();
			},

			// ======================
			// 新增/删除字段
			// ======================
			addField(rIdx) {
				this.regulatoryRecords[rIdx].fields.push({ label: '', key: '', value: '', type: 'text', max: 500, isDisplay: false,placeholder:"请输入编辑内容" });
			},
			delField(rIdx, fIdx) {
				this.regulatoryRecords[rIdx].fields.splice(fIdx, 1);
			},
			// ======================
			// 监管部门记录
			// ======================
			// 获取默认字段定义
			// ======================
			getDefaultFields(type) {
				if (type === 'type1') {
					return [
						{ key: '决定书文号', value: '', type: 'text', max: 50, isDisplay: true, placeholder: '请输入决定书文号' },
						{ key: '处罚事由', value: '', type: 'text', max: 1000, isDisplay: true, placeholder: '请输入处罚事由' },
						{ key: '处罚内容', value: '', type: 'text', max: 500, isDisplay: true, placeholder: '请输入处罚内容' },
						{ key: '处罚单位', value: '', type: 'text', max: 30 , isDisplay: true, placeholder: '请输入处罚单位'}
					];
				}
				return [
					{ key: '案件名称', value: '', type: 'text', max: 50, isDisplay: true, placeholder: '请输入案件名称' },
					{ key: '案号', value: '', type: 'text', max: 50, isDisplay: true, placeholder: '请输入案号' },
					{ key: '进程日期', value: null, type: 'date', max: 0, isDisplay: true, placeholder: '请选择日期' },
					{ key: '案件进程', value: '', type: 'text', max: 500, isDisplay: true, placeholder: '请输入案件进程' },
					{ key: '案件身份', value: '', type: 'text', max: 30, isDisplay: true, placeholder: '请输入案件身份' },
					{ key: '当事人', value: '', type: 'text', max: 30, isDisplay: true, placeholder: '请输入当事人' },
					{ key: '案件金额（元）', value: null, type: 'number', max: 0, isDisplay: true, placeholder: '请输入金额' },
					{ key: '判决结果', value: '', type: 'text', max: 1000, isDisplay: true, placeholder: '请输入判决结果' },
					{ key: '法院', value: '', type: 'text', max: 30 ,isDisplay: true, placeholder: '请输入法院'}
				];
			},
			// ======================
			// 新增记录
			// ======================
			addRegulatoryRecord() {
				var num = this.regulatoryRecords.length + 1;
				this.regulatoryRecords.push({
					_key: Date.now() + '_' + Math.random().toString(36).substr(2, 5),
					title: '记录' + num,
					fields: [{ key: '', value: '', type: 'text', placeholder: '请输入编辑内容', max: 500, isDisplay: true }]
				});
				this.$nextTick(function() {
					this.initRegulatoryRecordDrag();
				});
				this.handleFormChange();
			},
			// ======================
			// 删除记录
			// ======================
			delRegulatoryRecord(rIdx) {
				this.regulatoryRecords.splice(rIdx, 1);
				// 重新编号
				this.regulatoryRecords.forEach((item, idx) => {
					item.title = '记录' + (idx + 1);
				});
				this.handleFormChange();
			},
			// 新增行
			addRegulatoryRow(rIdx) {
				this.regulatoryRecords[rIdx].rows.push({
					_key: Date.now() + '_' + Math.random().toString(36).substr(2, 5),
					title: '',
					content: '',
					isDisplay: true
				});
				this.$nextTick(() => {

				});
				this.handleFormChange();
			},
			// 删除行
			delRegulatoryRow(rIdx, sIdx) {
				this.regulatoryRecords[rIdx].rows.splice(sIdx, 1);
				this.handleFormChange();
			},
			// 新增项
			addRegulatoryItem(rIdx, sIdx) {
				this.regulatoryRecords[rIdx].rows[sIdx].items.push({
					title: '',
					isDisplay: true
				});
				this.handleFormChange();
			},
			// 删除项
			delRegulatoryItem(rIdx, sIdx, iIdx) {
				this.regulatoryRecords[rIdx].rows[sIdx].items.splice(iIdx, 1);
				this.handleFormChange();
			},
			// 初始化记录内行级别的拖拽
			statusColor(status) {
				var map = { '存续': 'green', '注销': 'red', '迁出': 'orange' };
				return map[status] || 'default';
			},
			onBusinessStatusChange(val) {
				this.baseInfo.businessStatus = val;
				this.handleFormChange();
			},
			onBusinessStatusColorChange() {
				this.baseInfo.businessStatusColor = this.businessStatusColor;
				this.handleFormChange();
			},
			addTag() {
				var val = this.tagInput.trim();
				if (val && this.tagList.indexOf(val) === -1) {
					this.tagList.push(val);
					this.baseInfo.tags = this.tagList.join(';');
					this.form.setFieldsValue({ tags: this.baseInfo.tags });
					this.handleFormChange();
				}
				this.tagInput = '';
			},
			removeTag(idx) {
				this.tagList.splice(idx, 1);
				this.baseInfo.tags = this.tagList.join(';');
				this.form.setFieldsValue({ tags: this.baseInfo.tags });
				this.handleFormChange();
			},
			setRowRef(el, rIdx) {
				if (el) {
					this.$refs['regRowDrag_' + rIdx] = el;
				}
			},
			// 初始化顶级记录拖拽
			initRegulatoryRecordDrag() {
				const el = this.$refs.regulatoryRecordsDrag;
				if (!el) return;
				if (el._sortableInstance) {
					el._sortableInstance.destroy();
				}
				el._sortableInstance = Sortable.create(el, {
					animation: 150,
					ghostClass: 'sort-ghost',
					onEnd: (evt) => {
						const { oldIndex, newIndex } = evt;
						const moveItem = this.regulatoryRecords.splice(oldIndex, 1)[0];
						this.regulatoryRecords.splice(newIndex, 0, moveItem);
						// 重新编号
						this.regulatoryRecords.forEach((item, idx) => {
							item.title = '记录' + (idx + 1);
						});
					}
				});
				this.$nextTick(() => {
					this.initRegulatoryFieldDrag();
				});
			},
			// 字段拖拽
			initRegulatoryFieldDrag() {
				this.regulatoryRecords.forEach((record, rIdx) => {
					const el = this.$refs['regFieldDrag_' + rIdx];
					if (!el) return;
					const domEl = Array.isArray(el) ? el[0] : el;
					if (domEl._sortableInstance) {
						domEl._sortableInstance.destroy();
					}
					domEl._sortableInstance = Sortable.create(domEl, {
						animation: 150,
						ghostClass: 'sort-ghost',
						onEnd: (evt) => {
							const { oldIndex, newIndex } = evt;
							const moveItem = record.fields.splice(oldIndex, 1)[0];
							record.fields.splice(newIndex, 0, moveItem);
						}
					});
				});
			},
			// 提交时获取监管部门记录JSON字符串
			getRegulatoryRecordsSubmitStr() {
				return JSON.stringify(this.regulatoryRecords.map(function(record) {
					return (record.fields || []).map(function(f) {
						return { key: f.key || '', value: f.value || '', isDisplay: f.isDisplay !== false };
					});
				}));
			},

			// ======================
			// 表单提交（手动点击）
			// ======================
			handleSubmit() {
				this.form.validateFields(async (err, values) => {
					if (!err) {
						const saved = await this.saveData(values);
						if (saved) this.$message.success("保存成功");
					}
				});
			},
			// ======================
			// 保存方法（父组件调用）
			// ======================
			async saveData(values) {
				return factoryLicenseInfoApi({
						businessLangId: this.initialData.businessLangId,
						"businessDesc": values.businessDesc || "", // 品牌介绍
						"entityName": values.entityName || "", // 主体名称
						"logoUrl": values.logoUrl || "", // LOGO
						"unifiedSocialCreditCode": values.unifiedSocialCreditCode || "", // 统一社会信用代码
						"legalRepresentative": values.legalRepresentative || "", // 法人代表
						"registeredCapital": values.registeredCapital || "", // 注册资本
						"establishDate": values.establishDate || "", // 成立时间
						"businessStatus": values.businessStatus || "", // 存续状态
						"tags": this.tagList.join(';'), // 标签
						"industryCategory": values.industryCategory || "", // 国标行业
						"enterpriseScale": values.enterpriseScale || "", // 企业规模
						"employeeCount": values.employeeCount || "", // 员工人数
						"registeredAddress": values.registeredAddress || "", // 注册地址
						"businessScope": values.businessScope || "", // 经营范围
						"regulatoryRecords": this.getRegulatoryRecordsSubmitStr(),
					"businessStatusColor": this.businessStatusColor || "",
					"hasOwnFactoryStatus": this.hasOwnFactoryStatus,
					"hasOwnFactorylabel": this.hasOwnFactorylabel || "" // 监管部门记录
					})
					.then((res) => {
						if (res.resultStatus) {
							// 保存成功后更新原始数据，清除未保存状态
							this.originBaseInfo = JSON.parse(JSON.stringify(this.baseInfo));
							this.$emit("dirty", false);
							this.$emit("saved", { businessLangId: res.resultData });
							// this.editModel.flag = false;
							return true;
						} else {
							this.$message.error(res.errorMessage || '保存失败');
							return false;
						}
					})
					.catch(() => {
						this.$message.error('保存失败');
						return false;
					})

			},
		},
	};
</script>

<style scoped>
	.product-tab {
		padding: 16px;
	}

	.mt12 {
		margin-top: 12px;
	}

	.mr12 {
		margin-right: 12px;
	}

	.sort-ghost {
		opacity: 0.5;
		background: #f5f5f5;
	}

	.rich-editor {
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		padding: 4px 11px;
		min-height: 96px;
		line-height: 1.5;
		outline: none;
		transition: border-color 0.3s;
	}
	.rich-editor:focus {
		border-color: #1890ff;
		box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
	}
</style>
